/* Isolated product interactions. No changes to the approved home gallery. */
(() => {
  'use strict';
  const init = root => {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    const abort = new AbortController();
    const on = (node, type, handler, options = {}) => node && node.addEventListener(type, handler, {...options, signal: abort.signal});
    const track = root.querySelector('[data-pdp-track]');
    const slides = [...root.querySelectorAll('[data-pdp-slide]')];
    const thumbs = [...root.querySelectorAll('[data-pdp-thumb]')];
    const counter = root.querySelector('[data-pdp-count]');
    const form = root.querySelector('[data-pdp-form]');
    const primary = root.querySelector('[data-pdp-primary]');
    const sticky = root.querySelector('[data-pdp-sticky]');
    const zoom = root.querySelector('[data-pdp-zoom-dialog]');
    const bag = root.querySelector('[data-pdp-bag]');
    const status = root.querySelector('[data-pdp-status]');
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    let active = 0, frame = null, focusReturn = null, busy = false;
    const updateGallery = () => {
      frame = null;
      if (!track || !slides.length || !track.clientWidth) return;
      active = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / track.clientWidth)));
      thumbs.forEach((button, i) => button.setAttribute('aria-current', String(i === active)));
      if (counter) counter.textContent = `${String(active + 1).padStart(2,'0')} / ${String(slides.length).padStart(2,'0')}`;
    };
    const go = index => {
      if (!track || !slides.length) return;
      const next = Math.max(0, Math.min(slides.length - 1,index));
      track.scrollTo({left: next * track.clientWidth, behavior: reduced.matches ? 'auto' : 'smooth'});
    };
    on(track,'scroll',() => { if (!frame) frame = requestAnimationFrame(updateGallery); },{passive:true});
    on(track,'keydown',event => {
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); go(active + (event.key === 'ArrowRight' ? 1 : -1)); }
    });
    thumbs.forEach((button,i) => on(button,'click',() => go(i)));
    const syncSticky = () => {
      if (!sticky || !primary) return;
      sticky.hidden = primary.getBoundingClientRect().bottom > 0 || Boolean(document.querySelector('dialog[open]'));
    };
    const openDialog = dialog => {
      if (!dialog || typeof dialog.showModal !== 'function') return false;
      focusReturn = document.activeElement;
      dialog.showModal(); document.body.classList.add('vc-modal-open'); syncSticky();
      dialog.querySelector('button')?.focus(); return true;
    };
    const closeDialog = dialog => {
      dialog.close();
      if (!document.querySelector('dialog[open]')) document.body.classList.remove('vc-modal-open');
      if (focusReturn && document.contains(focusReturn)) focusReturn.focus({preventScroll:true});
      syncSticky();
    };
    [zoom,bag].filter(Boolean).forEach(dialog => {
      dialog.querySelectorAll('[data-pdp-close]').forEach(b => on(b,'click',() => closeDialog(dialog)));
      on(dialog,'cancel',event => { event.preventDefault(); closeDialog(dialog); });
      on(dialog,'close',() => { if(!document.querySelector('dialog[open]')) document.body.classList.remove('vc-modal-open'); if(focusReturn && document.contains(focusReturn)) focusReturn.focus({preventScroll:true}); syncSticky(); });
      on(dialog,'click',event => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if(event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) closeDialog(dialog);
      });
    });
    on(root.querySelector('[data-pdp-zoom]'),'click',() => {
      const image = slides[active]?.querySelector('img');
      if (!image || !zoom) return;
      const full = zoom.querySelector('img'); full.src = image.dataset.full || image.src; full.alt = image.alt;
      openDialog(zoom);
    });
    let observer;
    if (primary && sticky) {
      observer = new IntersectionObserver(syncSticky,{threshold:0}); observer.observe(primary);
      on(window,'scroll',syncSticky,{passive:true}); syncSticky();
    }
    on(window,'resize',() => { if(track) track.scrollLeft = active * track.clientWidth; syncSticky(); },{passive:true});
    const variantSelect = form?.querySelector('select[name="id"]');
    on(variantSelect,'change',() => {
      const option = variantSelect.selectedOptions[0];
      root.querySelectorAll('[data-pdp-price]').forEach(el => {el.textContent = option.dataset.price;});
      root.querySelectorAll('[data-pdp-currency]').forEach(el => {el.textContent = option.dataset.currency;});
      primary.disabled = option.dataset.available !== 'true';
      primary.querySelector('[data-pdp-label]').textContent = primary.disabled ? 'No disponible' : 'Añadir al carrito';
      if (sticky) sticky.querySelector('button').disabled = primary.disabled;
      const url = new URL(window.location.href); url.searchParams.set('variant',option.value); history.replaceState({},'',url);
    });
    on(form,'submit',async event => {
      event.preventDefault();
      if (busy || !primary || primary.disabled) return;
      busy = true;
      const buttons = [primary,...root.querySelectorAll('[data-pdp-sticky] button')];
      buttons.forEach(b => { b.disabled = true; b.setAttribute('aria-busy','true'); });
      const label = primary.querySelector('[data-pdp-label]'); const originalLabel = label.textContent; label.textContent = 'Añadiendo…';
      status.textContent = ''; status.dataset.error = 'false';
      const base = (window.Shopify?.routes?.root || '/');
      let added = false;
      try {
        const response = await fetch(base + 'cart/add.js',{method:'POST',body:new FormData(form),headers:{Accept:'application/json'},credentials:'same-origin'});
        const result = await response.json();
        if(!response.ok) throw new Error(result.description || 'No se pudo añadir el reloj. Inténtalo de nuevo.');
        added = true;
        if(bag) {
          const qty = bag.querySelector('[data-pdp-bag-quantity]'); if(qty) qty.textContent = `Cantidad añadida: ${new FormData(form).get('quantity') || 1}`;
          if(!openDialog(bag)) window.location.assign(root.dataset.cartUrl || base + 'cart');
        } else window.location.assign(root.dataset.cartUrl || base + 'cart');
        status.textContent = 'El reloj se añadió a tu bolsa.';
        try {
          const cartResponse = await fetch(base + 'cart.js',{headers:{Accept:'application/json'},credentials:'same-origin'});
          if(cartResponse.ok) {
            const cart = await cartResponse.json();
            document.querySelectorAll('.vc-cart-count').forEach(el => el.textContent = cart.item_count);
            document.querySelectorAll('.vc-header__actions a').forEach(a => { if(a.querySelector('.vc-cart-count')) a.setAttribute('aria-label',`Bolsa de compra, ${cart.item_count} artículos`); });
          }
        } catch (_) { /* The item was added. Do not suggest retrying an already successful add. */ }
      } catch(error) {
        status.dataset.error = 'true';
        status.textContent = added ? 'El reloj está en tu bolsa. Abre la bolsa para continuar.' : (error.message || 'No se pudo conectar. Revisa tu conexión e inténtalo de nuevo.');
      } finally {
        busy = false; label.textContent = originalLabel;
        buttons.forEach(b => { b.disabled = false; b.removeAttribute('aria-busy'); }); syncSticky();
      }
    });
    on(document,'shopify:section:unload',event => { if(event.target.contains(root)) {observer?.disconnect(); abort.abort(); if(frame) cancelAnimationFrame(frame);} });
    updateGallery();
  };
  const boot = () => document.querySelectorAll('[data-pdp]').forEach(init);
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',boot,{once:true}); else boot();
  document.addEventListener('shopify:section:load',boot);
})();
